// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__26e9N","loader":"Loader_loader__1flAs"};